import i18n from '../../../../i18n';

/** 后台审批字段名 → H5 表单字段名 */
export const ERROR_KEY_ALIASES: Record<string, string> = {
  accountNo: 'bankAccountNo',
  bank: 'bankCode',
  transfer: 'transfer_prove',
  lastNameCn: 'fullName',
  firstNameCn: 'fullName',
  /** 审核 opinion 通用退回 key，与 backReason 同义（对齐 App openAccount.fields.backReason） */
  rejectReason: 'backReason',
  /** 后台衍生产品认知 key → 表单 hasDerivativeKnowledge */
  derivativeProductKnowledge: 'hasDerivativeKnowledge',
};

/** 后台笼统 key → 需同时高亮的证件附件字段 */
const IDENTITY_ATTACHMENT_FIELDS = [
  'identity_front',
  'identity_back',
  'hongkong_identity',
  'macao_identity',
  'passport',
];

export function normalizeErrorKey(key: string): string {
  return ERROR_KEY_ALIASES[key] ?? key;
}

/** 审批退回字段 key → 展示文案（先归一别名再查 i18n） */
export function getErrorFieldLabel(key?: string | null): string {
  if (!key) return '';
  const normalized = normalizeErrorKey(key);
  const fields = i18n.OpenProgress?.ErrorFields as Record<string, string> | undefined;
  return fields?.[normalized] || fields?.[key] || key;
}

export function normalizeOpinionItems<T extends { key: string; message: string }>(items: T[]): T[] {
  return items.map((item) => ({ ...item, key: normalizeErrorKey(item.key) }));
}

/** App / 审核 opinion：支持数组或 JSON 字符串 */
export function parseOpinionPayload(raw: unknown): Array<{ key: string; message: string; dataForm?: string }> {
  if (raw == null || raw === '') return [];
  let value = raw;
  if (typeof value === 'string') {
    try {
      value = JSON.parse(value);
    } catch {
      return [];
    }
  }
  return Array.isArray(value) ? value : [];
}

export function applyOpinionErrors(items: Array<{ key: string; message: string; dataForm?: string }>) {
  const normalized = normalizeOpinionItems(items);
  return {
    errorKeys: normalized.map((i) => i.key),
    errorValues: normalized,
    errorMaps: normalized.reduce<Record<string, string>>((map, i) => {
      map[i.key] = i.message;
      return map;
    }, {}),
  };
}

export function isErrorField(field: string, errorKeys: string[]): boolean {
  if (!field) return false;
  if (errorKeys.includes(field)) return true;
  if (errorKeys.some((k) => normalizeErrorKey(k) === field)) return true;
  // 后台 key=identity：证件正反面 / 护照等附件一并提示
  if (errorKeys.includes('identity') && IDENTITY_ATTACHMENT_FIELDS.includes(field)) {
    return true;
  }
  return false;
}
